import React, { Fragment } from 'react';
import Breadcrumbs from '../../../CommonElements/Breadcrumbs';
import UsersEditContain from '../../../Component/Users/UsersEdit';
import { useTranslation } from 'react-i18next';

const UsersEdit = () => {
  const { t } = useTranslation();

  return (
    <Fragment>
      <Breadcrumbs parent={t("Users")} title={t("User Edit")} />
      <UsersEditContain />
    </Fragment>
  );
};
export default UsersEdit;
